import MapUIConfig, { GeoJsonProperties, PathComposition } from '../types/config'
import { FeatureWithId } from '../types/geojson'

export const compositionToDashArray = (
  composition: PathComposition | undefined,
  weight: number,
): string | undefined => {
  if (!composition || composition === 'solid') return undefined

  if (composition === 'dashesNarrowSpace') {
    return `${weight * 2.5} ${weight * 1.5}`
  } else if (composition === 'dashesMediumSpace' || composition === 'dashes') {
    return `${weight * 2.5} ${weight * 3}`
  } else if (composition === 'dashesWideSpace') {
    return `${weight * 2.5} ${weight * 6}`
  } else if (composition === 'narrowDashesNarrowSpace') {
    return `${weight * 2} ${weight * 1.5}`
  } else if (composition === 'narrowDashesMediumSpace') {
    return `${weight * 2} ${weight * 2}`
  } else if (composition === 'narrowDashesWideSpace') {
    return `${weight * 2} ${weight * 6}`
  } else if (composition === 'dotsNarrowSpace') {
    return `1 ${weight * 1.5}`
  } else if (composition === 'dotsMediumSpace' || composition === 'dots') {
    return `1 ${weight * 2}`
  } else if (composition === 'dotsWideSpace') {
    return `1 ${weight * 3}`
  }

  throw new Error('MAP-5: Unknown PathComposition')
}

export const getConfigForType = <TProperties extends GeoJsonProperties = GeoJsonProperties, TRenderContext = unknown>(
  config: MapUIConfig<TProperties, TRenderContext>,
  type: string,
) => {
  const featureConfig = config.featureConfig[type]
  if (!featureConfig) throw new Error('MAP-1: No config available for the given feature')
  return featureConfig
}

export const getConfigForFeature = <
  TProperties extends GeoJsonProperties = GeoJsonProperties,
  TRenderContext = unknown,
>(
  config: MapUIConfig<TProperties, TRenderContext>,
  feature: FeatureWithId<TProperties>,
) => {
  // Get feature meta config from config
  return getConfigForType(config, feature.properties.type)
}
